var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M53.2 467L32 96h384l-21.2 371a48 48 0 0 1-47.9 45H101.1a48 48 0 0 1-47.9-45z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 80V48a16 16 0 0 1 16-16h120l9.4-18.7A23.72 23.72 0 0 1 166.8 0h114.3a24 24 0 0 1 21.5 13.3L312 32h120a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16A16 16 0 0 1 0 80z","className":"fa-primary","key":2})]);
}

Trash.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Trash;

Trash.default = Trash;
